import { Component, OnInit } from '@angular/core';
import { StateService } from '../../../core/services/state.service';
import { DataTaskService } from '../../../core/services/data-task.service';

@Component({
  selector: 'tt-order-line-credit-cause-lang',
  templateUrl: './order-line-credit-cause-lang.component.html',
  styleUrls: ['./order-line-credit-cause-lang.component.css']
})
export class OrderLineCreditCauseLangComponent implements OnInit {
    orderLineCreditCauseKeyno;

    public inputListLanguages: InputLanguageItem[] = [];

    public saving = false;

    constructor(private stateService: StateService, private datatask: DataTaskService) {
        this.orderLineCreditCauseKeyno = this.stateService.getStateParams()['orderlinecreditcause_keyno'];
    }

    private async loadLanguages(): Promise<void> {
        if (!!this.orderLineCreditCauseKeyno) {
            this.inputListLanguages = await this.datatask.Post(2764, { orderlinecreditcause_keyno: this.orderLineCreditCauseKeyno });
        }
    }

    public async saveChanges() {
        if (!!this.inputListLanguages) {
            try {
                this.saving = true;

                await this.datatask.Post(2765, { records: this.inputListLanguages });

                this.stateService.back();
            } finally {
                this.saving = false;
            }
        }
    }

    private async init() {
        this.loadLanguages();
    }

    ngOnInit() {
        this.init();
    }
}

interface InputLanguageItem {
    orderlinecreditcause_keyno: number;
    orderlinecreditcauselang_name: string;
    language_id: string;
    language_name: string;
    orderby: number;
}

//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('orderLineCreditCauseLang', {
//        templateUrl: 'views/components/views/orderLineCreditCauseLang/orderLineCreditCauseLang.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['$stateParams', 'stateService', 'translateService', 'modalService', 'orderLineCreditCauseLangService', function ($stateParams, stateService, translateService, modalService, orderLineCreditCauseLangService) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;
//            let orderLineCreditCauseKeyno = $stateParams.orderlinecreditcause_keyno;

//            let translations = {
//                confirmation: '',
//                error: '',
//                ok: ''
//            };

//            vm.model = {
//                inputListLanguages: [],
//                lockedSave: false
//            };

//            // #endregion VARIABLES & DEFINITIONS

//            // #region TRANSLATE SERVICE

//            async function translate() {
//                let data = await translateService.translateBatch(translations);

//                Object.keys(translations).forEach((key) => {
//                    if (data?.[key]) translations[key] = data[key];
//                });
//            }

//            // #endregion TRANSLATE SERVICE

//            // #region LOAD PROCEDURE FUNCTION CALLS

//            async function loadLanguages() {
//                vm.model.inputListLanguages = await orderLineCreditCauseLangService.listOrderLineCreditCauseLanguages({ orderlinecreditcause_keyno: orderLineCreditCauseKeyno });
//            }

//            // #endregion LOAD PROCEDURE FUNCTION CALLS

//            // #region BUTTON SAVE PROCEDURE FUNCTION CALL

//            vm.saveChanges = function () {
//                vm.model.lockedSave = true;

//                orderLineCreditCauseLangService.saveObj({ records: vm.model.inputListLanguages }).then((response) => {
//                    if (response[0] && response[0].ws_result === '1') {
//                        modalService.show({
//                            type: 'success',
//                            title: translations.confirmation,
//                            message: response[0].ws_result_message,
//                            buttons: [{
//                                label: translations.ok,
//                                cssClass: 'btn-success',
//                                action: (dialogItself) => {
//                                    dialogItself.close();
//                                    vm.model.lockedSave = false;
//                                    stateService.back();
//                                }
//                            }]
//                        });
//                    } else {
//                        vm.model.lockedSave = false;
//                    }
//                });
//            };

//            // #endregion BUTTON SAVE PROCEDURE FUNCTION CALL

//            // #region ON INIT FUNCTION

//            vm.$onInit = function () {
//                translate();
//                loadLanguages();
//            }

//            // #endregion ON INIT FUNCTION

//        }]
//    });
//})();
